module.exports = __webpack_public_path__ + "static/media/Purdue-University-Logo-500x281.8f8fe7bd.png";